import styled from 'styled-components';
import { themeZIndex } from '../../../theme/getters';
import { slideFromDownTransition } from '../../../theme/transitions';

export const AnimationContainer = styled.div`
  position: ${props => (props.theme.isTransitioning ? 'fixed' : 'relative')};
  width: 100%;
  left: 0;
  top: 0;
  z-index: ${themeZIndex('overlay')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  ${slideFromDownTransition};
`;
